
import { sprintf } from 'sprintf-js';

/**
 * Given a price in cents, returns a string in dollars.
 */
const centsToString = (price) => {
  if (price === 0) {
    return "$0";
  }
  if (!price) {
    return "$0";
  }
  let prefix = "";
  if (price < 0) {
    prefix = "-";
    price *= -1;
  }
  const cents = Math.abs(price % 100);
  const dollars = price / 100;
  let dollarStr = sprintf("%d", dollars);
  dollarStr = dollarStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return sprintf("%s$%s.%02d", prefix, dollarStr, cents);
};

const dollarToString = (price, no_cents) => {
  let result = centsToString(Math.round(price * 100));
  if (no_cents && result.length > 3) {
    result = result.substr(0, result.length - 3);
  }
  return result;
};

/**
 * bps is in tenths of a basis point.
 */
const bpsToString = (bps) => {
  if (!bps) {
    return 0;
  }
  return sprintf("%f", bps);
};

/**
 * Calculates the fee price.
 *
 * @param price Cents
 * @param deci_bps Tenths of a BPS
 * @return the fee in cents
 */
const calcFee = (price, deci_bps) => {
  return Math.floor(price * deci_bps * 0.00001);
};

const price_string_to_dollars = (str) => {
  if (!str) {
    return 0;
  }
  str = str.replace("$", "");
  str = str.replace(",", "");
  if (str === "") {
    return 0;
  }
  return parseFloat(str);
}

const price_string_to_cents = (str) => {
  return Math.round(price_string_to_dollars(str) * 100);
};

export { centsToString, dollarToString, bpsToString, calcFee,
  price_string_to_dollars, price_string_to_cents };
